<template>
  <scout-form
    :is-modified="appliesOtherCompany"
    label="他社求人への応募"
  >
    <label class="boss-checkbox">
      <input
        :checked="appliesOtherCompany"
        class="boss-input-checkbox"
        type="checkbox"
        data-test="applies-other-company"
        @change="$emit('update:appliesOtherCompany', $event.target.checked)"
      >他社の求人へ応募済みの会員を除外
    </label>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'

export default {
  components: {
    ScoutForm
  },
  props: {
    appliesOtherCompany: {
      default: false,
      type: Boolean
    }
  }
}
</script>
